/* tb-ak-packtisch: Kalender packen (Produkt antippen = nächstes Türchen, auffüllen), Summe, Versand-Hinweis,
   alles mit einem /cart/add.js in den Warenkorb. Daten aus [data-akp-daten] (Liquid).
   Runde 3 (20.10.2026): oben nur Starter-Produkte + "Mehr Produkte entdecken", die Slider darunter (tb-adventskalender-selbst)
   legen über dieselbe Funktion ins Türchen; Mischungen erscheinen unten als vorgepackte Karten ([data-akp-karte]). */
(function () {
  var root = document.querySelector('[data-akp]');
  if (!root) return;
  var D;
  try { D = JSON.parse(root.querySelector('[data-akp-daten]').textContent); } catch (e) { return; }
  var POOL = D.pool || [], KITS = D.kits || {}, BY = {};
  POOL.forEach(function (p) { BY[p.h] = p; });
  var NAME = { food: 'Food', beauty: 'Beauty', lifestyle: 'Lifestyle' };
  var SPEICHER = 'tbak-packtisch';
  var ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var versandAb = Math.round(parseFloat(String(root.dataset.versandAb || '').replace(',', '.')) * 100) || 0;
  var PLUS = '<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M9 2v14M2 9h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var HAKEN = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10.5l4 4 8-9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var liste = root.querySelector('[data-akp-liste]');
  var tipp = root.querySelector('[data-akp-tipp]');
  var fehler = root.querySelector('[data-akp-fehler]');
  var kaufen = root.querySelector('[data-akp-kaufen]');
  var mehrBox = root.querySelector('[data-akp-mehr-box]');
  var kal = [];   // Index = Türchen - 1, Eintrag {h, v} oder null (entferntes Türchen bleibt frei)
  var wahl = {};  // gewählte Sorte je Produkt in der Liste
  var zugZeit = 0;

  // Starter: Liste aus den Einstellungen, sonst je die ersten zwei aus Food, Beauty, Lifestyle (nur Verfügbares)
  var START = (D.start || []).filter(function (h) { return BY[h]; });
  if (!START.length) {
    ['food', 'beauty', 'lifestyle'].forEach(function (k) {
      POOL.filter(function (p) { return p.k === k; }).slice(0, 2).forEach(function (p) { START.push(p.h); });
    });
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function eur(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  function sorte(h, id) { var vs = BY[h].v; for (var i = 0; i < vs.length; i++) if (vs[i][0] === id) return vs[i]; return vs[0]; }
  function bild(h, v) { var s = sorte(h, v); return (s && s[3]) || BY[h].b || ''; }
  // Rabattstaffel (23.10.2026): [[ab Anzahl, Prozent], …] aus Liquid; zählen nur Produkte mit "r" (Tag der Rabatt-Kollektion).
  // Rechnet wie Shopify: je Stück abgerundet, mal Menge (im echten Warenkorb gemessen 23.10.2026: 995 × 10 % = 99,
  // 13 × 129 × 5 % = 13 × 6 = 78), damit Seite und Kasse auf den Cent gleich sind.
  var STAFFEL = (D.staffel || []).filter(function (s) { return s[0] > 0 && s[1] > 0; }).sort(function (a, b) { return a[0] - b[0]; });
  function rabatt(eintraege) {
    var n = 0, p = 0, naechste = null, cent = 0, mit = [];
    eintraege.forEach(function (x) { if (BY[x.h].r) { n++; mit.push(sorte(x.h, x.v)[2]); } });
    STAFFEL.forEach(function (s) { if (n >= s[0]) p = s[1]; else if (!naechste) naechste = s; });
    if (p) mit.forEach(function (preis) { cent += Math.floor(preis * p / 100); });
    return { n: n, p: p, cent: cent, naechste: naechste };
  }
  function voll() { return kal.filter(Boolean); }
  function frei() { var i = kal.indexOf(null); return i < 0 ? kal.length : i; }
  function anzahl(h) { return kal.filter(function (x) { return x && x.h === h; }).length; }
  function speichern() { try { localStorage.setItem(SPEICHER, JSON.stringify(kal)); } catch (e) {} }
  function kitKnopf(id) { document.querySelectorAll('[data-akp-kit]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.akpKit === id ? 'true' : 'false'); }); }
  function ruhig() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  // Gespeicherten Kalender übernehmen, soweit Produkt und Sorte noch verfügbar sind
  try {
    kal = (JSON.parse(localStorage.getItem(SPEICHER) || '[]') || []).slice(0, 24).map(function (x) {
      return x && BY[x.h] ? { h: x.h, v: sorte(x.h, x.v)[0] } : null;
    });
    while (kal.length && kal[kal.length - 1] === null) kal.pop();
  } catch (e) { kal = []; }

  if (D.ab) { var ab = root.querySelector('[data-akp-ab]'); if (ab) { ab.innerHTML = 'Türchen ab <b>' + esc(D.ab) + '</b>'; ab.hidden = false; } }

  function zeigeListe() {
    var n = voll().length;
    liste.innerHTML = START.map(function (h) {
      var p = BY[h], v = sorte(h, wahl[h]), c = anzahl(h);
      var sel = p.v.length > 1
        ? '<label class="akp__sorte"><span class="akp__vh">Sorte für ' + esc(p.t) + '</span><select data-akp-sorte="' + esc(p.h) + '">' +
          p.v.map(function (x) { return '<option value="' + x[0] + '"' + (x[0] === v[0] ? ' selected' : '') + '>' + esc(x[1]) + '</option>'; }).join('') + '</select></label>'
        : '';
      return '<li class="akp__item" data-k="' + p.k + '"><img src="' + esc(v[3] || p.b || '') + '" alt="" loading="lazy" width="72" height="86">' +
        '<div><span class="akp__marke">' + esc(p.m) + '</span><p class="akp__titel">' + esc(p.t) + '</p><p class="akp__p">' + eur(v[2]) + '</p>' + sel + '</div>' +
        '<div><button type="button" class="akp__plus" data-akp-add="' + esc(p.h) + '" aria-label="' + esc(p.t) + ' ins nächste Türchen legen"' + (n >= 24 ? ' disabled' : '') + '>' + PLUS + '</button>' +
        (c ? '<div class="akp__anzahl">' + c + '× drin</div>' : '') + '</div></li>';
    }).join('');
  }

  // Produktkarten in den Slidern: kleine Marke "1× im Kalender" am Bild
  function markiereKarten() {
    document.querySelectorAll('.tbak__karte[data-h]').forEach(function (k) {
      var c = anzahl(k.dataset.h), b = k.querySelector('.tbak__bild');
      if (!b) return;
      if (c) b.setAttribute('data-in', c + '× im Kalender'); else b.removeAttribute('data-in');
    });
  }

  function zeige(neu) {
    root.querySelectorAll('.akp__tuer').forEach(function (el) {
      var tag = +el.dataset.tag, x = kal[tag - 1], im = el.querySelector('img');
      el.classList.remove('is-neu');
      if (x) {
        var p = BY[x.h], v = sorte(x.h, x.v), src = bild(x.h, x.v);
        if (el.dataset.h !== x.h || el.dataset.v !== String(v[0])) {
          if (im) im.remove();
          var b = document.createElement('img');
          b.src = src; b.alt = ''; el.insertBefore(b, el.firstChild);
          if (!el.querySelector('.akp__weg')) { var w = document.createElement('span'); w.className = 'akp__weg'; w.textContent = 'Entfernen'; w.setAttribute('aria-hidden', 'true'); el.appendChild(w); }
        }
        el.dataset.h = x.h; el.dataset.v = String(v[0]);
        el.classList.add('is-voll');
        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', 'Türchen ' + tag + ': ' + p.t + (v[1] ? ', ' + v[1] : '') + '. Antippen zum Entfernen');
        el.tabIndex = 0;
        if (neu === tag) el.classList.add('is-neu');
      } else {
        if (im) im.remove();
        var w2 = el.querySelector('.akp__weg'); if (w2) w2.remove();
        delete el.dataset.h; delete el.dataset.v;
        el.classList.remove('is-voll');
        el.removeAttribute('role'); el.removeAttribute('aria-label'); el.removeAttribute('tabindex');
      }
    });
    var v = voll(), n = v.length, summe = 0, m = { food: 0, beauty: 0, lifestyle: 0 };
    v.forEach(function (x) { summe += sorte(x.h, x.v)[2]; m[BY[x.h].k]++; });
    var r = rabatt(v), alt = root.querySelector('[data-akp-alt]'), rt = root.querySelector('[data-akp-rabatt]');
    if (alt) { alt.hidden = !r.cent; alt.textContent = r.cent ? eur(summe) : ''; }
    if (rt && STAFFEL.length) {
      var ziel = r.naechste;
      rt.classList.toggle('is-drin', !!r.p);
      // Am Handy klebt die Summe unten: dort nur der erste Satz (.akp__rabatt-weiter ausgeblendet), die Stufen stehen im Kopf
      rt.innerHTML = r.p
        ? esc(r.p + ' % Rabatt sind drin, du sparst ' + eur(r.cent) + '.') + (ziel ? '<span class="akp__rabatt-weiter"> Noch ' + (ziel[0] - r.n) + (ziel[0] - r.n === 1 ? ' Produkt' : ' Produkte') + ' bis ' + ziel[1] + ' %.</span>' : '')
        : (n && ziel ? esc('Noch ' + (ziel[0] - r.n) + (ziel[0] - r.n === 1 ? ' Produkt' : ' Produkte') + ' bis ' + ziel[1] + ' % Rabatt.')
        : '<b>' + esc(STAFFEL.map(function (s) { return s[1] + ' % Rabatt ab ' + s[0] + ' Produkten'; }).join(' & ')) + '</b>');
    }
    summe -= r.cent;
    root.querySelector('[data-akp-zahl]').textContent = n;
    root.querySelector('[data-akp-preis]').textContent = eur(summe);
    ['food', 'beauty', 'lifestyle'].forEach(function (k) {
      root.querySelector('.akp__mix .' + k).style.width = (m[k] / 24 * 100) + '%';
      root.querySelector('[data-akp-l="' + k + '"]').textContent = NAME[k] + ' ' + m[k];
    });
    var vs = root.querySelector('[data-akp-versand]');
    if (vs) {
      vs.classList.toggle('is-frei', versandAb > 0 && summe >= versandAb);
      vs.textContent = !versandAb || !n ? '' : summe >= versandAb ? 'Dein Kalender ist versandkostenfrei.' : 'Noch ' + eur(versandAb - summe) + ' bis versandkostenfrei.';
    }
    kaufen.disabled = !n;
    kaufen.textContent = n === 1 ? '1 Produkt in den Warenkorb' : n ? 'Alle ' + n + ' in den Warenkorb' : 'In den Warenkorb';
    root.querySelectorAll('[data-akp-leeren]').forEach(function (b) { b.disabled = !n; });
    var dnd = root.querySelector('[data-akp-dnd]');
    if (dnd) { dnd.hidden = n < 2; dnd.textContent = touch ? 'Türchen gedrückt halten und ziehen, um die Reihenfolge zu tauschen.' : 'Türchen ziehen, um die Reihenfolge zu tauschen.'; }
    // "Mehr Produkte entdecken" ab der ersten Auswahl hervorheben (Lene 20.10.), vorher bleibt es als ruhiger Hinweis stehen
    if (mehrBox) { mehrBox.hidden = false; mehrBox.classList.toggle('is-aktiv', n > 0); }
    zeigeListe();
    markiereKarten();
    speichern();
    document.dispatchEvent(new CustomEvent('akp:aenderung', { detail: { n: n, summe: summe, text: eur(summe) } }));
  }

  function sagTipp(text) { if (tipp) tipp.textContent = text; }
  function tippNachStand() {
    var n = voll().length, m = { food: 0, beauty: 0, lifestyle: 0 };
    voll().forEach(function (x) { m[BY[x.h].k]++; });
    if (!n) return sagTipp('Tipp auf ein Produkt, dann liegt es im nächsten Türchen.');
    if (n >= 24) return sagTipp('Alle 24 Türchen sind voll. Tipp auf ein Türchen, um es zu tauschen.');
    var wenig = ['food', 'beauty', 'lifestyle'].sort(function (a, b) { return m[a] - m[b]; })[0];
    sagTipp('Noch ' + (24 - n) + ' Türchen frei. Am wenigsten hast du bisher aus ' + NAME[wenig] + '.');
  }

  // Eine Mischung auflösen: Ausverkauftes durch ein verfügbares Produkt der gleichen Kategorie mit ähnlichem Preis ersetzen
  function loeseKit(kit) {
    var benutzt = {}, ersetzt = 0;
    kit.h.forEach(function (e) { if (BY[e[0]]) benutzt[e[0]] = 1; });
    var eintraege = kit.h.slice(0, 24).map(function (e) {
      var h = e[0], k = e[1], preis = e[2];
      if (BY[h]) return { h: h, v: BY[h].v[0][0] };
      var kand = POOL.filter(function (p) { return !benutzt[p.h] && (!k || p.k === k); });
      if (!kand.length) return null;
      kand.sort(function (a, b) { return Math.abs(a.v[0][2] - preis) - Math.abs(b.v[0][2] - preis); });
      benutzt[kand[0].h] = 1; ersetzt++;
      return { h: kand[0].h, v: kand[0].v[0][0] };
    });
    return { eintraege: eintraege, ersetzt: ersetzt };
  }

  function ladeKit(id) {
    var kit = KITS[id]; if (!kit) return;
    var r = loeseKit(kit);
    kal = r.eintraege;
    while (kal.length && kal[kal.length - 1] === null) kal.pop();
    kitKnopf(id);
    zeige();
    sagTipp('Mischung „' + kit.titel + '“ geladen. ' + (kit.satz ? kit.satz + ' ' : '') +
      (r.ersetzt ? r.ersetzt + (r.ersetzt === 1 ? ' Produkt war' : ' Produkte waren') + ' ausverkauft, dafür liegt etwas Ähnliches drin. ' : '') +
      'Tipp auf ein Türchen, um es zu tauschen.');
    if (fehler) fehler.textContent = '';
  }

  function auffuellen() {
    var m = { food: 0, beauty: 0, lifestyle: 0 };
    voll().forEach(function (x) { m[BY[x.h].k]++; });
    var rest = POOL.filter(function (p) { return !anzahl(p.h); });
    while (voll().length < 24 && rest.length) {
      var wenig = ['food', 'beauty', 'lifestyle'].sort(function (a, b) { return m[a] - m[b]; })[0];
      var kand = rest.filter(function (p) { return p.k === wenig; });
      if (!kand.length) kand = rest;
      var p = kand[Math.floor(Math.random() * Math.min(kand.length, 6))];
      kal[frei()] = { h: p.h, v: p.v[0][0] };
      m[p.k]++;
      rest.splice(rest.indexOf(p), 1);
    }
    kitKnopf(null);
    zeige();
    tippNachStand();
  }

  // Warenkorb: alles in einem Aufruf; scheitert er (z. B. eine Sorte gerade ausverkauft), einzeln nachlegen
  function korb(items) {
    function add(it) {
      return fetch(ROUTE + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: it }) })
        .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); });
    }
    var alle = items.reduce(function (s, it) { return s + it.quantity; }, 0);
    return add(items).then(function () { return { drin: alle, fehlt: 0 }; }).catch(function () {
      var drin = 0, fehlt = 0;
      return items.reduce(function (kette, it) {
        return kette.then(function () { return add([it]).then(function () { drin += it.quantity; }).catch(function () { fehlt += it.quantity; }); });
      }, Promise.resolve()).then(function () {
        if (!drin) throw new Error('Das hat nicht geklappt. Bitte versuch es noch einmal.');
        return { drin: drin, fehlt: fehlt };
      });
    });
  }
  function zuItems(eintraege) {
    var z = {}, reihe = [];
    eintraege.forEach(function (x) { if (!z[x.v]) { z[x.v] = 0; reihe.push(x.v); } z[x.v]++; });
    return reihe.map(function (id) { return { id: id, quantity: z[id] }; });
  }

  function inDenWarenkorb() {
    var items = zuItems(voll());
    kaufen.disabled = true; kaufen.setAttribute('aria-busy', 'true'); kaufen.textContent = 'Wird eingepackt …';
    if (fehler) fehler.textContent = '';
    korb(items).then(function (e) {
      document.dispatchEvent(new CustomEvent('akp:warenkorb', { detail: e }));
      kaufen.textContent = 'Liegt im Warenkorb';
      kal = []; speichern();
      if (e.fehlt) {
        // Nicht sofort weiterleiten, damit der Hinweis gelesen werden kann
        if (fehler) fehler.innerHTML = esc(e.drin + ' Produkte liegen im Warenkorb, ' + e.fehlt + ' waren gerade ausverkauft. ') + '<a href="' + ROUTE + 'cart">Zum Warenkorb</a>';
        kaufen.removeAttribute('aria-busy');
      } else {
        setTimeout(function () { location.href = ROUTE + 'cart'; }, 600);
      }
    }).catch(function (err) {
      if (fehler) fehler.textContent = err.message;
      kaufen.removeAttribute('aria-busy');
      zeige();
    });
  }

  // ---- Vorgepackte Mischungen unten (Darstellung wie Variante D), die Karten liegen in tb-adventskalender-selbst ----
  function zeigeKarten() {
    document.querySelectorAll('[data-akp-karte]').forEach(function (el) {
      var id = el.dataset.akpKarte, kit = KITS[id];
      if (!kit || el.dataset.fertig) return;
      var r = loeseKit(kit), e = r.eintraege.filter(Boolean), summe = 0;
      if (!e.length) return;
      e.forEach(function (x) { summe += sorte(x.h, x.v)[2]; });
      var rk = rabatt(e);
      el.dataset.fertig = '1';
      el._akpItems = zuItems(e);
      el.innerHTML =
        '<ol class="tbak__mosaik" aria-hidden="true">' + e.map(function (x, i) {
          return '<li><img src="' + esc(bild(x.h, x.v)) + '" alt="" loading="lazy" width="150" height="180"><span>' + (i + 1) + '</span></li>';
        }).join('') + '</ol>' +
        '<details class="tbak__kitliste"><summary>Alle ' + e.length + ' Türchen ansehen</summary><ol>' + e.map(function (x, i) {
          var p = BY[x.h], v = sorte(x.h, x.v);
          return '<li><span>' + (i + 1) + '. ' + esc(p.t) + (v[1] ? ' (' + esc(v[1]) + ')' : '') + '</span><span>' + eur(v[2]).replace(' ', ' ') + '</span></li>';
        }).join('') + '</ol></details>' +
        '<div class="tbak__kitfuss"><p class="tbak__kitpreis">' + e.length + ' Produkte, du zahlst<b>' +
        (rk.cent ? '<s class="tbak__kitalt">' + eur(summe).replace(' ', ' ') + '</s> ' : '') + eur(summe - rk.cent).replace(' ', ' ') + '</b>' +
        (rk.cent ? '<span class="tbak__kitrabatt">inklusive ' + rk.p + ' % Kalender-Rabatt</span>' : '') + '</p>' +
        '<div class="tbak__kitknoepfe"><button type="button" class="tbak__btn" data-akp-kitkauf>Mischung in den Warenkorb</button>' +
        '<button type="button" class="tbak__btn tbak__btn--info" data-akp-kit="' + esc(id) + '">Im Kalender anpassen</button></div></div>' +
        '<p class="tbak__kitstatus" role="status" aria-live="polite"></p>';
    });
  }

  document.addEventListener('click', function (e) {
    var kk = e.target.closest('[data-akp-kitkauf]');
    if (!kk) return;
    var el = kk.closest('[data-akp-karte]'), st = el.querySelector('.tbak__kitstatus');
    var alt = kk.textContent;
    kk.disabled = true; kk.textContent = 'Wird eingepackt …'; st.textContent = '';
    korb(el._akpItems).then(function (r) {
      kk.textContent = 'Liegt im Warenkorb';
      st.innerHTML = esc(r.fehlt ? r.drin + ' Produkte liegen im Warenkorb, ' + r.fehlt + ' sind gerade ausverkauft. ' : r.drin + ' Produkte liegen im Warenkorb. ') +
        '<a href="' + ROUTE + 'cart">Zum Warenkorb</a>';
      document.dispatchEvent(new CustomEvent('akp:kitkorb', { detail: r }));
      setTimeout(function () { kk.textContent = alt; }, 2600);
    }).catch(function (err) { kk.textContent = alt; st.textContent = err.message; }).then(function () { kk.disabled = false; });
  });

  // ---- Produkte aus den Slidern unten ins Türchen legen ----
  function zeigeMehr(k) {
    var ziel = document.querySelector('.tbak__kat--' + k) || document.querySelector('.tbak__kat');
    if (ziel) ziel.scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'start' });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.tbak__karte [data-tbak-add]');
    if (!b) return;
    var karte = b.closest('.tbak__karte'), h = karte && karte.dataset.h;
    if (!h || !BY[h]) return; // unbekanntes Produkt: die Section legt dann wie gewohnt in den Warenkorb
    e.preventDefault(); e.stopPropagation();
    var vorher = b.dataset.text || (b.dataset.text = b.innerHTML);
    clearTimeout(b._t);
    if (voll().length >= 24) {
      b.textContent = 'Alle 24 Türchen sind voll';
    } else {
      var sel = karte.querySelector('[data-tbak-sorte]'), id = sel ? +sel.value : +b.dataset.variante;
      var i = frei();
      kal[i] = { h: h, v: sorte(h, id)[0] };
      kitKnopf(null);
      zeige(i + 1);
      tippNachStand();
      b.classList.add('is-drin');
      b.innerHTML = HAKEN + 'Türchen ' + (i + 1);
    }
    b._t = setTimeout(function () { b.classList.remove('is-drin'); b.innerHTML = vorher; }, 1800);
  }, true);

  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-akp-sorte]');
    if (!sel) return;
    wahl[sel.dataset.akpSorte] = +sel.value;
    var item = sel.closest('.akp__item');
    var preis = item.querySelector('.akp__p'), v = sorte(sel.dataset.akpSorte, +sel.value);
    if (preis) preis.textContent = eur(v[2]);
    var im = item.querySelector('img'); if (im && v[3]) im.src = v[3]; // zur Sorte passendes Bild (Lene 20.10.)
  });

  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-akp-add]');
    if (a) {
      if (voll().length >= 24) return;
      var h = a.dataset.akpAdd, i = frei();
      kal[i] = { h: h, v: sorte(h, wahl[h])[0] };
      kitKnopf(null);
      zeige(i + 1);
      tippNachStand();
      return;
    }
    var t = e.target.closest('.akp__tuer.is-voll');
    if (t) {
      if (Date.now() - zugZeit < 450) return; // Klick direkt nach Ziehen oder langem Drücken entfernt nichts
      kal[+t.dataset.tag - 1] = null;
      while (kal.length && kal[kal.length - 1] === null) kal.pop();
      kitKnopf(null);
      zeige();
      sagTipp('Türchen ' + t.dataset.tag + ' ist wieder frei. Das nächste Produkt landet dort.');
      return;
    }
    var m = e.target.closest('[data-akp-mehr]');
    if (m) { zeigeMehr(m.dataset.akpMehr); return; }
    if (e.target.closest('[data-akp-leeren]')) { kal = []; kitKnopf(null); zeige(); tippNachStand(); return; }
    if (e.target.closest('[data-akp-auffuellen]')) { auffuellen(); return; }
    if (e.target.closest('[data-akp-kaufen]') && voll().length) inDenWarenkorb();
  });

  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('is-voll')) { e.preventDefault(); e.target.click(); }
  });

  // "Im Kalender anpassen" (Karten unten): Mischung laden und zum Packtisch springen
  document.addEventListener('click', function (e) {
    var kt = e.target.closest('[data-akp-kit]');
    if (!kt) return;
    ladeKit(kt.dataset.akpKit);
    root.querySelector('.akp__tisch').scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'start' });
  });

  // ---- Reihenfolge per Ziehen tauschen (Maus und Touch) ----
  // Ziehen auf ein anderes Türchen tauscht beide, auf ein leeres verschiebt. Die Nummern bleiben 1 bis 24.
  // Maus: ab 6 px Bewegung. Touch: erst nach 280 ms Drücken, damit das Scrollen der Seite nicht kaputtgeht.
  var zug = null; // zugZeit: Zeitpunkt des letzten Ziehens (oben deklariert, wird im Klick geprüft)
  function tuerAn(x, y) { var el = document.elementFromPoint(x, y); return el && el.closest && el.closest('.akp__tuer'); }
  function tausche(a, b) {
    var n = Math.max(kal.length, a, b);
    while (kal.length < n) kal.push(null);
    var t = kal[a - 1]; kal[a - 1] = kal[b - 1] || null; kal[b - 1] = t || null;
    while (kal.length && kal[kal.length - 1] === null) kal.pop();
    kitKnopf(null);
    zeige();
    sagTipp(kal[a - 1] ? 'Türchen ' + a + ' und ' + b + ' getauscht.' : 'Türchen ' + a + ' nach ' + b + ' verschoben.');
  }
  function zugStart() {
    if (!zug || zug.laeuft) return;
    zug.laeuft = true; zugZeit = Date.now();
    var q = zug.el, r = q.getBoundingClientRect(), g = q.cloneNode(true);
    g.className = 'akp__geist'; g.removeAttribute('role'); g.removeAttribute('tabindex'); g.removeAttribute('aria-label');
    g.style.width = r.width + 'px'; g.style.height = r.height + 'px';
    document.body.appendChild(g); zug.geist = g;
    q.classList.add('is-zieht');
    document.body.classList.add('akp-zieht');
    zugBewegen(zug.x, zug.y);
  }
  function zugBewegen(x, y) {
    if (!zug || !zug.geist) return;
    zug.geist.style.transform = 'translate(' + (x - zug.geist.offsetWidth / 2) + 'px,' + (y - zug.geist.offsetHeight / 2) + 'px) scale(1.06)';
    var ziel = tuerAn(x, y);
    root.querySelectorAll('.akp__tuer.is-ziel').forEach(function (e) { if (e !== ziel) e.classList.remove('is-ziel'); });
    if (ziel && ziel !== zug.el) ziel.classList.add('is-ziel');
  }
  function zugEnde(abbruch) {
    if (!zug) return;
    clearTimeout(zug.timer);
    var z = zug; zug = null;
    document.removeEventListener('pointermove', zugMove); document.removeEventListener('pointerup', zugUp); document.removeEventListener('pointercancel', zugAb);
    document.removeEventListener('touchmove', zugTouch);
    if (z.geist) {
      z.geist.remove();
      z.el.classList.remove('is-zieht');
      document.body.classList.remove('akp-zieht');
      var ziel = abbruch ? null : tuerAn(z.x, z.y);
      root.querySelectorAll('.akp__tuer.is-ziel').forEach(function (e) { e.classList.remove('is-ziel'); });
      if (ziel && ziel !== z.el && root.contains(ziel)) tausche(+z.el.dataset.tag, +ziel.dataset.tag);
      zugZeit = Date.now();
    }
  }
  function zugMove(e) {
    if (!zug || e.pointerId !== zug.id) return;
    zug.x = e.clientX; zug.y = e.clientY;
    if (!zug.laeuft && zug.maus && Math.hypot(zug.x - zug.x0, zug.y - zug.y0) > 6) zugStart();
    if (!zug.laeuft && !zug.maus && Math.hypot(zug.x - zug.x0, zug.y - zug.y0) > 10) zugEnde(true); // Finger bewegt sich vor dem Halten: Seite scrollt
    else zugBewegen(zug.x, zug.y);
  }
  function zugUp(e) { if (zug && e.pointerId === zug.id) zugEnde(false); }
  function zugAb(e) { if (zug && e.pointerId === zug.id) zugEnde(true); }
  function zugTouch(e) { if (zug && zug.laeuft) e.preventDefault(); } // hält die Seite still, solange gezogen wird
  root.addEventListener('pointerdown', function (e) {
    var t = e.target.closest('.akp__tuer.is-voll');
    if (!t || (e.pointerType === 'mouse' && e.button !== 0) || zug) return;
    zug = { el: t, id: e.pointerId, x: e.clientX, y: e.clientY, x0: e.clientX, y0: e.clientY, maus: e.pointerType === 'mouse', laeuft: false };
    if (!zug.maus) zug.timer = setTimeout(zugStart, 280);
    document.addEventListener('pointermove', zugMove);
    document.addEventListener('pointerup', zugUp);
    document.addEventListener('pointercancel', zugAb);
    document.addEventListener('touchmove', zugTouch, { passive: false });
  });
  root.addEventListener('contextmenu', function (e) { if (e.target.closest('.akp__tuer')) e.preventDefault(); });
  root.addEventListener('dragstart', function (e) { if (e.target.closest('.akp__tuer')) e.preventDefault(); }); // kein Browser-Bildziehen

  // Tastatur: Umschalt + Pfeiltasten tauscht das Türchen mit seinem Nachbarn (links/rechts ±1, oben/unten ±6)
  root.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('.akp__tuer.is-voll');
    if (!t || !e.shiftKey) return;
    var d = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -6, ArrowDown: 6 }[e.key];
    if (!d) return;
    var a = +t.dataset.tag, b = a + d;
    if (b < 1 || b > 24) return;
    e.preventDefault();
    tausche(a, b);
    var neu = root.querySelector('.akp__tuer[data-tag="' + b + '"]'); if (neu) neu.focus();
  });

  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  zeigeKarten();
  zeige();
  tippNachStand();
})();
